import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { createReduxHistoryContext, RouterState } from 'redux-first-history';
import thunkMiddleware from 'redux-thunk';
import { createHistory } from 'src/libs/history';

export interface IReduxState {
	router: RouterState;
}

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
	history: createHistory(),
	basename: '/',
});

const store = configureStore({
	reducer: combineReducers({
		router: routerReducer,
	}),
	middleware: [thunkMiddleware, routerMiddleware],
});
// @ts-ignore
window.store = store;

export const history = createReduxHistory(store);

export default store;
